// extracted by mini-css-extract-plugin
module.exports = {"channel":"Channel_channel__39SYd","provider":"Channel_provider__hc0HE","icon":"Channel_icon__fDOE8","badge":"Channel_badge__2MAxN","date":"Channel_date__21gTD"};